<div *ngIf="result" class="container pt-3 pb-3">
  <div fxLayout="row" class="h-100" fxLayoutAlign="stretch center" fxLayoutGap="10px">
    <div>
      <div class="circle" [class.active]="result.Active"></div>
    </div>
    <div fxFlex>
      <div [innerHtml]="result.Label1"></div>
      <div *ngIf="!canWatchConfidential()"> {{ 'COMMON.NO-PERMISSION-TO-CONFIDENTIAL' | translate }}</div>
      <div *ngIf="canWatchConfidential()"> {{ 'COMMON.AGE' | translate }} {{ result.Age || '-' }}</div>
      <div *ngIf="canWatchConfidential()"> {{ result.Phone }} 
        <span *ngIf="result.Phone2"><span class="m-2">|</span> {{ result.Phone2 }}</span>
      </div>
    </div>
    <div>
      <mat-icon class="mat-icon-xlg pointer" color="primary" (click)="onSelect($event)" *ngIf="canWatchConfidential() && settings.rtl">
        navigate_before</mat-icon>
      <mat-icon class="mat-icon-xlg pointer" color="primary" (click)="onSelect($event)" *ngIf="canWatchConfidential() && !settings.rtl">
        navigate_next</mat-icon>
    </div>
  </div>
</div>
